<template>
  <a-card>
    <a-form-model
      :model="form"
      :labelCol="{ xl: 7, lg: 6 }"
      :wrapperCol="{ xl: 17, lg: 18 }"
    >
      <a-row :gutter="[24, 24]">
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="业务类型">
            <a-select
              allowClear
              showSearch
              v-model="form.business"
              @change="handleBusinessChange"
              option-filter-prop="children"
            >
              <a-select-option
                v-for="optionItem in businessList"
                :value="optionItem.id"
                :key="optionItem.id"
              >
                {{ optionItem.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="业务模式">
            <a-select
              allowClear
              showSearch
              v-model="form.model"
              option-filter-prop="children"
            >
              <a-select-option
                v-for="optionItem in modelOptionList"
                :value="optionItem.id"
                :key="optionItem.id"
              >
                {{ optionItem.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="大区">
            <a-select
              allowClear
              showSearch
              v-model="form.region"
              option-filter-prop="children"
            >
              <a-select-option
                v-for="optionItem in regionOptionList"
                :value="optionItem.id"
                :key="optionItem.id"
              >
                {{ optionItem.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="信用主管">
            <a-select
              allowClear
              showSearch
              v-model="form.creditManager"
              option-filter-prop="children"
            >
              <a-select-option
                v-for="manager in managerList"
                :key="manager.username"
              >
                {{ manager.name }} - {{ manager.username }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item label="默认评分卡">
            <a-select
              allowClear
              showSearch
              v-model="form.defaultScoreType"
              option-filter-prop="children"
            >
              <a-select-option
                v-for="item in scorecard"
                :value="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xxl="6" :xl="8" :lg="12">
          <a-form-model-item>
            <a-button
              icon="download"
              type="primary"
              @click="_getRequiredList"
              :loading="loading"
            >
              导出
            </a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <a-collapse style="margin-top: 30px">
      <a-collapse-panel
        v-for="(item, index) in treeData"
        :key="item.index"
        :header="item.title"
      >
        <a-tree
          checkable
          :tree-data="[...item]"
          @check="(checkedKeys, e) => onSelect(checkedKeys, e, index)"
        />
      </a-collapse-panel>
    </a-collapse>
    <a-modal
      :width="600"
      title="条件选择"
      :visible="visible"
      :maskClosable="false"
    >
      <template #footer>
        <a-button key="back" @click="handleCancel">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loadingExport"
          @click="handleOk"
        >
          确定
        </a-button>
      </template>
      <div class="list-container">
        <div
          class="list-item"
          v-for="(item, index) in requiredList"
          :key="index"
        >
          <span>{{ item.sheetName }}：</span>
          <div class="content">
            <a-date-picker
              style="width: 100%"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              v-model="item.dateValue"
              v-if="item.type === 1"
              :allowClear="false"
            />
            <a-range-picker
              style="width: 100%"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              v-model="item.dateValue"
              v-else-if="item.type === 2"
              :allowClear="false"
            />
            <div v-else-if="item.type === 3">
              <a-row :gutter="24">
                <a-col
                  :span="
                    item.parameters[item.parameters.length - 1] === 'channel'
                      ? 12
                      : 24
                  "
                >
                  <customize-link
                    v-model="item.dateValue"
                    mode="month"
                    format="YYYY-MM"
                    valueFormat="YYYY-MM"
                  />
                </a-col>
                <a-col
                  v-if="
                    item.parameters[item.parameters.length - 1] === 'channel'
                  "
                  :span="12"
                >
                  <a-select v-model="channel" style="width: 100%">
                    <a-select-option value="IFC明细">IFC明细</a-select-option>
                    <a-select-option value="阜锦明细">阜锦明细</a-select-option>
                    <a-select-option value="联想金融明细">
                      联想金融明细
                    </a-select-option>
                    <a-select-option value="中行明细">中行明细</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </div>
            <customize-link
              v-else-if="item.type === 4"
              v-model="item.dateValue"
              mode="year"
              format="YYYY"
              valueFormat="YYYY"
            />
          </div>
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
// import moment from 'moment'
import mixin from './mixin'
import {
  getList,
  getBusinessList,
  download,
  getConditions,
  getRegionList,
  getManagerList,
} from './api'
import CustomizeLink from './customizeLink'
import { SCORE_CARD_SCHEMA } from '@/utils/staticData.js'
//import axios from 'axios'
// const YEAR_END = 'end'
const REGION_TYPE = 2,
  MODEL_TYPE = 3,
  CREDIT_AREA_TYPE = 4

export default {
  mixins: [mixin],
  data() {
    return {
      form: {
        business: '',
        model: '',
        region: '',
        creditManager: '',
        defaultScoreType: '',
      },
      businessList: [],
      managerList: [],
      visible: false,
      regionOptionList: [],
      scorecard: [],
      modelOptionList: [], // 业务模式列表
      requiredList: [],
      SCORE_CARD_SCHEMA,
      loading: false,
      loadingExport: false,
      channel: '',
    }
  },
  mounted() {
    this.getScore()
    this._getList()
    this.fetchBusinessList()
    this.fetchManagerList()
  },
  methods: {
    async handleOk() {
      this.loadingExport = true
      const result = this._checkForm()
      if (result) {
        const submitData = this._formatFormData()
        await this._downLoad(submitData)
      }
    },
    async _downLoad(parameters) {
      const result = this._checkSelect()
      await download({
        business: this.form.business,
        model: this.form.model,
        region: this.form.region,
        creditManager: this.form.creditManager,
        defaultScoreType: this.form.defaultScoreType,
        fields: result,
        parameters,
      })
      this.$message.success('成功')
      this.visible = false
      this.loadingExport = false
    },
    _formatFormData() {
      let newArr = []
      for (let i = 0; i < this.requiredList.length; i++) {
        const { sheetName, type, parameters, dateValue } = this.requiredList[i]
        const obj = {}
        obj.sheetName = sheetName
        if (type !== 1) {
          obj.startDate = dateValue[0]
          obj.endDate = dateValue[1]
        } else {
          obj.execDate = dateValue
        }
        if (parameters[parameters.length - 1] === 'channel') {
          obj.channel = this.channel
        }
        newArr.push(obj)
      }
      return newArr
    },
    _checkForm() {
      for (let i = 0; i < this.requiredList.length; i++) {
        const defaultValue = this.requiredList[i].dateValue
        if (
          (typeof defaultValue === 'string' && defaultValue === '') ||
          (Array.isArray(defaultValue) && !defaultValue.length)
        ) {
          this.$message.warning('请选择内容')
          return false
        }
        const parameters = this.requiredList[i].parameters
        if (parameters[parameters.length - 1] === 'channel' && !this.channel) {
          this.$message.warning('请选择内容')
          return false
        }
      }
      return true
    },
    handleCancel() {
      this.visible = false
    },
    getScore() {
      this.scorecard = this.SCORE_CARD_SCHEMA
    },
    handleBusinessChange(value) {
      if (!value) {
        this.modelOptionList = []
        this.regionOptionList = []
      } else {
        ;[REGION_TYPE, MODEL_TYPE, CREDIT_AREA_TYPE].forEach(type => {
          this.fetchRegionList(value, type)
        })
      }
    },
    async fetchRegionList(pid, type) {
      try {
        const { data } = await getRegionList({ pid, type })
        this.setOptionListByType(type, data)
      } catch (error) {
        console.error(error)
      }
    },
    setOptionListByType(type, data) {
      switch (type) {
        case REGION_TYPE:
          this.regionOptionList = data
          return
        case MODEL_TYPE:
          this.modelOptionList = data
          return
      }
    },
    async fetchBusinessList() {
      try {
        const { data } = await getBusinessList()
        this.businessList = data
      } catch (error) {
        console.error(error)
      }
    },
    async fetchManagerList() {
      try {
        const { data } = await getManagerList()
        this.managerList = data
      } catch (error) {
        console.error(error)
      }
    },
    handleOpenChange(status, name) {
      this[name] = status
    },
    _getList() {
      getList().then(({ data }) => {
        this.treeData = data.map((item, index) => {
          return {
            title: item.sheet,
            children: item.cells.map(child => ({
              title: child,
              key: child,
            })),
            index,
          }
        })
      })
    },
    _checkSelect() {
      const formData = []
      for (let i = 0; i < this.treeData.length; i++) {
        const arrKeys = this[`checkedKeys-${i}`]
        if (arrKeys && arrKeys.length) {
          formData.push({
            sheet: this.getSheetName(i),
            cells: this.remove(arrKeys),
          })
        }
      }
      if (formData && formData.length == 0) {
        this.$notification.warning({
          message: '提示',
          description: '请选择导出的内容！',
        })
        return false
      }
      return formData
    },
    async _getRequiredList() {
      const result = this._checkSelect()
      if (result) {
        this.loading = true
        try {
          const { data } = await getConditions({
            business: this.form.business,
            model: this.form.model,
            region: this.form.region,
            creditManager: this.form.creditManager,
            defaultScoreType: this.form.defaultScoreType,
            fields: result,
          })
          if (data.length) {
            this.requiredList = data.map(item => {
              if (item.type !== 1) {
                return { ...item, dateValue: [] }
              }
              return { ...item, dateValue: '' }
            })
            if (this.requiredList.length) {
              this.visible = true
            }
            this.loading = false
          } else {
            const parameters = {
              business: this.form.business,
              model: this.form.model,
              region: this.form.region,
              creditManager: this.form.creditManager,
              defaultScoreType: this.form.defaultScoreType,
              fields: result,
            }
            await download(parameters)
            this.$message.success('成功')
            this.loading = false
          }
        } catch (err) {
          this.loading = false
        }
      }
    },
    // 拿到原tree data title
    getSheetName(num) {
      return this.treeData.filter(item => item.index === num)[0].title
    },
    // 删除无用的key
    remove(arr) {
      const newArr = [...arr]
      const index = newArr.findIndex(item => item === '0-0')
      if (index !== -1) {
        newArr.splice(index, 1)
      }
      return newArr
    },
  },
  components: {
    CustomizeLink,
  },
}
</script>

<style scoped lang="less">
.segmentation {
  margin: 0 20px;
}
.export-button {
  margin-left: 30px;
  position: relative;
  top: 12px;
}

.search {
  margin-bottom: 50px;
}

.ant-form-item {
  margin-bottom: 0;
}
.list-item {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  span {
    width: 100px;
  }
  .content {
    flex: 1;
  }
}
</style>
